
export interface IBaseModel {
  uuid?: string;
}

export class BaseModel {
  uuid?: string;

  constructor(data: IBaseModel) {
    this.uuid = data.uuid;
  }
}